module.exports = __webpack_public_path__ + "img/neto.f7252d6e.jpeg";